<!-- TODO: column id (or other way) to tell how to style this cell -->
<div class="cell-container"
    [class.readonly]="readonly">
    <ng-container *ngIf="readonly | equals:false; else readonlyContent">
        <multi-line-text-input [value]="value" (valueChange)="_handleValueChange($event)" (input)="_handleInput($event)" (focus)="_handleFocus($event)" (blur)="_handleBlur($event)" (keydown)="_handleKeydown($event)" (copy)="_purgeEvent($event)" (cut)="_purgeEvent($event)" (paste)="_purgeEvent($event)"></multi-line-text-input>
    </ng-container>
    <ng-template #readonlyContent>
        <div class="content">{{ value }}</div>
    </ng-template>
</div>